/** Compact iframe-preview styles so the report fits the panel without horizontal overflow. */
export const PREVIEW_IFRAME_STYLES = `
<style id="pl-preview-iframe-styles">
  html, body {
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: hidden !important;
    box-sizing: border-box !important;
  }

  .content-wrapper {
    border: 1px solid #0066cc !important;
    border-radius: 4px !important;
    padding: 8px !important;
    margin: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    overflow-x: auto !important;
    overflow-y: visible !important;
    background: #ffffff !important;
  }
  @media print {
    .content-wrapper {
      border: none !important;
    }
  }

  .pageStyle,
  .report-page-header,
  .report-header-row,
  .section-header-block,
  .combined-section-header,
  .accountingGroupClassification_accountingGroup_container {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
  }

  .report-header-row,
  .section-header-row {
    flex-wrap: wrap !important;
    gap: 8px !important;
  }

  .report-header-client-block {
    max-width: 100% !important;
  }

  .table {
    width: 100% !important;
    max-width: 100% !important;
    table-layout: fixed !important;
    font-size: 10px !important;
  }

  .table th,
  .table td {
    padding: 2px 4px !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    white-space: normal !important;
    font-size: 11px !important;
  }

  .table thead th,
  .td-header,
  .td-header-1 {
    font-size: 11px !important;
  }

  .td-last,
  .td-amount-cell,
  .td-percentage,
  .td-last-sum,
  .td-last-sum-1,
  .td-header-sub-amount,
  .td-header-sub-pct,
  .accounting-amount-value {
    white-space: normal !important;
    font-size: 10px !important;
  }

  .td-account-cell,
  .table td:first-child.total-palcode,
  .table td:first-child.total-palcode-final {
    font-size: 11px !important;
    line-height: 1.25 !important;
    white-space: normal !important;
    min-width: 0 !important;
  }

  .accounting-amount-underline-double,
  .accounting-amount-underline-triple,
  .accounting-amount-underline-dotted {
    min-width: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
  }

  .report-title { font-size: 14px !important; }
  .report-date-range { font-size: 10px !important; }
  .report-client-name { font-size: 11px !important; }
  .report-client-case,
  .report-print-datetime { font-size: 10px !important; }
  .sums-of-transactions,
  .section-header-title { font-size: 13px !important; }
  .overflowed { font-size: 10px !important; }
</style>
`;

export const EDITABLE_IFRAME_STYLES = `
<style id="pl-editable-iframe-styles">
  .td-amount-cell[data-editable-cell] { cursor: pointer; }

  .td-amount-cell.pl-editable-selected,
  .td-amount-cell.pl-editable-edited {
    background: #fffde7 !important;
  }

  .td-account-cell[data-editable-account-name] { cursor: pointer; }

  .td-account-cell.pl-editable-selected,
  .td-account-cell.pl-editable-edited {
    background: #fffde7 !important;
  }

  .pl-editable-cell-input {
    width: 100%;
    height: 100%;
    border: 2px solid #304FFF;
    outline: none;
    background: #ffffff;
    color: inherit;
    font: inherit;
    text-align: inherit;
    direction: inherit;
    box-sizing: border-box;
    padding: 0 4px;
  }

  tr.pl-editable-data-row .pl-editable-account-cell-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    width: 100%;
    min-width: 0;
  }

  tr.pl-editable-data-row .pl-editable-account-label {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  tr.pl-editable-data-row .pl-editable-row-actions {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    flex-shrink: 0;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.15s ease;
  }

  tr.pl-editable-data-row:hover .pl-editable-row-actions {
    opacity: 1;
    pointer-events: auto;
  }

  .pl-editable-row-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    padding: 0;
    border: 1px solid #c5cae9;
    border-radius: 4px;
    background: #ffffff;
    color: #304FFF;
    font-size: 13px;
    line-height: 1;
    cursor: pointer;
  }

  .pl-editable-row-action:hover {
    background: #eef2ff;
    border-color: #304FFF;
  }

  .pl-editable-row-action--delete {
    color: #c05621;
    border-color: #ffd8b2;
  }

  .pl-editable-row-action--delete:hover {
    background: #fff1e3;
    border-color: #c05621;
  }

  tr.pl-editable-added-row > td {
    background-color: #e9f5ff !important;
  }

  tr.pl-editable-added-row:hover > td {
    background-color: #d4ebff !important;
  }

  tr.pl-editable-empty-add-row > td.pl-editable-empty-add-cell {
    padding: 4px 6px !important;
    text-align: center !important;
    background: #f5f8ff !important;
    border: 1px dashed #c5cae9 !important;
  }

  .pl-editable-empty-add-btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 10px;
    border: 1px solid #c5cae9;
    border-radius: 4px;
    background: #ffffff;
    color: #304FFF;
    font: inherit;
    font-size: 11px;
    line-height: 1.4;
    cursor: pointer;
  }

  .pl-editable-empty-add-btn:hover {
    background: #eef2ff;
    border-color: #304FFF;
  }

  @media print {
    .pl-editable-row-actions { display: none !important; }
    .pl-editable-empty-add-row { display: none !important; }
  }
</style>
`;

export const wrapHtmlForPreview = (html, { includeEditableStyles = false, direction = 'rtl' } = {}) => {
  if (!html) return html;

  let result = html;
  const extraStyles = includeEditableStyles ? EDITABLE_IFRAME_STYLES : '';

  if (result.includes('<html')) {
    result = result.replace(/<html([^>]*)>/i, (match, attrs) => {
      if (/dir=/i.test(attrs)) {
        return `<html${attrs.replace(/dir="[^"]*"/i, `dir="${direction}"`)}>`;
      }
      return `<html${attrs} dir="${direction}">`;
    });
  }

  if (result.includes('<body')) {
    result = result.replace(/<body([^>]*)>/i, (match, attrs) => {
      if (/dir=/i.test(attrs)) {
        return `<body${attrs.replace(/dir="[^"]*"/i, `dir="${direction}"`)}>`;
      }
      return `<body${attrs} dir="${direction}">`;
    });
  }

  if (!result.includes('pl-preview-iframe-styles')) {
    if (result.includes('</head>')) {
      result = result.replace('</head>', `${PREVIEW_IFRAME_STYLES}${extraStyles}</head>`);
    } else {
      result = `${PREVIEW_IFRAME_STYLES}${extraStyles}${result}`;
    }
  } else if (includeEditableStyles && !result.includes('pl-editable-iframe-styles')) {
    if (result.includes('</head>')) {
      result = result.replace('</head>', `${EDITABLE_IFRAME_STYLES}</head>`);
    }
  }

  return result;
};
